import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const modalDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    margin: `${-space.s16}px ${space.s70}px ${space.s24}px 0`,
  },
]);

export const actionsContainer = style([
  {
    display: 'flex',
    gap: space.s8,
    marginTop: space.s48,
  },
]);

globalStyle(`${actionsContainer} > button`, {
  flex: `1 1 0`,
});

export const targetTag = style([
  {
    background: themeVars.container.secondary.background.idle,
    borderRadius: borderRadius.r64,
    paddingLeft: space.s12,
    paddingRight: space.s4,
    height: 32,
  },
]);

export const targetsBottomTip = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s8,
  },
]);

export const addedTargets = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: space.s4,
  marginBottom: space.s16,
});

export const listsHeader = style([
  typography.bodyMd,
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s8,
    padding: `${space.s8}px ${space.s12}px`,
    color: themeVars.container.foreground.secondary,
  },
]);

export const lists = style({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 320,
  overflowY: 'auto',
  border: `1px solid ${themeVars.container.border.default}`,
  borderRadius: borderRadius.r12,
});

export const listRow = style([
  typography.bodyMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s12,
    padding: `${space.s8}px ${space.s12}px`,
    cursor: 'pointer',
    ':hover': {
      background: themeVars.container.secondary.background.idle,
    },
  },
]);

export const listRowText = style({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const listRowName = style({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const listRowDeck = style([
  typography.bodySm,
  {
    color: themeVars.container.foreground.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
]);
